module.exports = __webpack_public_path__ + "87c4e5a8aed09a5ed944eea4f813e43a.png";